import { U2000FormStateEnumState } from '../../u2000Core/reducer/formReducer/U2000FormState';
import type { U3141MasterLotChain } from '../U3141Service';

export type U3141MasterLotChainHistoriqueActionStateInput = {
  formState: U2000FormStateEnumState;
  masterData: U3141MasterLotChain | null | undefined;
  fetchHistoriqueCadastralCooldown: boolean;
  hasRoleRegfon: boolean;
  hasRoleEdit: boolean;
  openReconstituteChainFromPdfAvailable: boolean;
};

export type U3141MasterLotChainHistoriqueActionState = {
  canShowFetchHistoriqueCadastral: boolean;
  fetchHistoriqueCadastralDisabled: boolean;
  canShowImportChainFromPdf: boolean;
  importChainFromPdfDisabled: boolean;
};

/** Guards partagés toolbar + menu graphe lot demandé (BL-0609 / BL-0702). */
export function u3141MasterLotChainHistoriqueActionState(
  input: U3141MasterLotChainHistoriqueActionStateInput,
): U3141MasterLotChainHistoriqueActionState {
  const currentId = input.masterData?.id;
  const hasHistoriqueCadastralSauvegarde = Boolean(input.masterData?.hasHistoriqueCadastralSauvegarde);
  const formEdit = input.formState === U2000FormStateEnumState.EDIT;
  const canFetchHistoriqueCadastral = input.hasRoleRegfon || input.hasRoleEdit;

  return {
    canShowFetchHistoriqueCadastral: canFetchHistoriqueCadastral,
    fetchHistoriqueCadastralDisabled:
      formEdit || !currentId || input.fetchHistoriqueCadastralCooldown,
    canShowImportChainFromPdf: input.hasRoleRegfon,
    importChainFromPdfDisabled:
      formEdit ||
      !currentId ||
      hasHistoriqueCadastralSauvegarde ||
      !input.openReconstituteChainFromPdfAvailable,
  };
}
